/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { AppealTypes, MonitoringState } from 'store/modules/monitoring_store/types';
import Api from 'services/api';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';

interface TradingMessageAppealItemProps {
  appeal: AppealTypes;
}

interface AppealProgressTypes {
  created_at: string;
  facilitator_appeals_id: number;
  id: number;
  message: string;
  updated_at: string;
  url: string;
}

const TradingMessageAppealItem = (props: TradingMessageAppealItemProps) => {
  const { appeal } = props;

  const [appealProgresses, setAppealProgresses] = useState<Array<AppealProgressTypes>>([]);

  const { monitoring } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );

  useEffect(() => {
    Api.get(`/facilitadores/appeals_progresses.json?appeal_id=${appeal.id}`).then((response) => {
      setAppealProgresses(response.data?.data ? response.data?.data : response.data);
    });
  }, []);

  return (
    <div className="row mb-3">
      <div className="col-12">
        {appeal.url === null ? (
          <strong>{appeal.message}</strong>
        ) : (
          <strong>
            <a href={appeal.url} target="blank">
              {appeal.message}
            </a>
          </strong>
        )}
      </div>
      {appealProgresses?.length > 0 && (
        <div className="col-12">
          <div className="p-2 border rounded">
            <ul className="nav flex-column">
              {appealProgresses?.map((appealProgress, index) => (
                <li key={`trading_item_${index}`}>
                  <a key={`trading_item_${index}`} href={appealProgress.url} target="blank">
                    {appealProgress.message}
                    <span
                      style={{ display: 'inline-block' }}
                      className={
                        monitoring.appeals_notifications.find(
                          (appealNotification) =>
                            appealNotification.appeal_id === appealProgress.facilitator_appeals_id,
                        )
                          ? 'bg-danger monitoring-notification ml-1'
                          : ''
                      }
                    />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default TradingMessageAppealItem;
